import commandApi from '@/api/command.api'

/**
 * Servicio para recursos de command
 */
export const commandService = (function () {
    'use strict'

    /**
     * Reporte de comandos enviados
     * @param {*} ids
     * @param {*} from
     * @param {*} to
     */
    async function getSentCommandsReport (ids, from, to) {
        try {
            const response = await commandApi.getSentCommandsReport(ids, from, to)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                headers: [],
                data: []
            }
        }
    }

    /**
     * Envío de comandos (carga masiva)
     * Devuelve los headers y datos de la tabla
     * @param {*} things
     * @param {*} commands
     * @param {*} forwardingInterval
     * @param {*} forwardingMaxAttemptTime
     */
    async function sendCommandsMassiveUpload (things, commands, forwardingInterval, forwardingMaxAttemptTime) {
        try {
            const response = await commandApi.sendCommandsMassiveUpload(things, commands, forwardingInterval, forwardingMaxAttemptTime)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                headers: [],
                data: []
            }
        }
    }

    /**
     * Para actualizar los datos de la tabla luego del envío masivo de comandos
     * @param {*} commandIds
     */
    async function getMassiveUploadData (commandIds) {
        try {
            const response = await commandApi.getMassiveUploadData(commandIds)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                headers: [],
                data: []
            }
        }
    }

    return {
        getSentCommandsReport,
        sendCommandsMassiveUpload,
        getMassiveUploadData
    }
})()
